
export const colorPickerStyles = {
  default: {
    picker: {
      width: '264px',
      height: 'auto',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '0px',

    },
    saturation: {
      cursor: 'pointer',
      borderRadius: '4px',
    },
    hue: {
      borderRadius: '100px',
      height: '8px',
      marginTop: '10px',
      marginBottom: '10px',
      cursor: 'pointer',
    },
    alpha: {
      borderRadius: '100px',
      height: '8px',
      marginTop: '10px',
      marginBottom: '10px',
      cursor: 'pointer',
    },

  },
};

export const presetColors = [
  '#00C853', '#FF0000', '#FFC400',
  '#FF1493', '#AAFF00', '#9400D3',
  '#FF00FF', '#40E0D0', '#8B4513',
  '#808080', '#C0C0C0', '#FFC0CB',
  '#008080', '#000000', '#A52A2A', '#808081',
  '#D3D3D3',
];
